import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {TlPagination} from "../../../../interfaces/general-interfaces";
import {SettingsHttpService} from "../../../../services/http-services/settings/settings-http.service";
import { TranslateModule } from '@ngx-translate/core';
import {NgForOf, NgIf} from "@angular/common";
import {MatchLocaleModule} from '../../../../pipes/match-locale/match-locale.module';

@Component({
  selector: 'tl-insights-content-you-create',
  standalone: true,
  imports: [TranslateModule, NgIf, NgForOf, MatchLocaleModule],
  templateUrl: './insights-content-you-create.component.html',
})
export class InsightsContentYouCreateComponent implements OnChanges {
  @Input() urlParams: any = {page: 1, from_date: null, to_date: null};
  @Output() clickOnList: EventEmitter<any> = new EventEmitter<any>();
  insightsLists: any[] = [];
  insightsListsPagination: TlPagination | undefined;
  isRequestFinish = false;
  constructor(private settingsHttpService: SettingsHttpService) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.insightsLists = [];
    this.insightsListsPagination = undefined;
    if (changes.urlParams) {
      this.urlParams = changes.urlParams.currentValue;
      this.getInsightsLists();
    }
  }

  getInsightsLists(): void {
    this.isRequestFinish = false;
    this.urlParams.page = this.insightsListsPagination?.currentPage ? this.insightsListsPagination.currentPage + 1 : 1;
    this.settingsHttpService.getInsightsLists(this.urlParams).then((res: any) => {
      this.insightsLists = [...this.insightsLists, ...res.data];
      this.insightsListsPagination = res.pagination;
      this.isRequestFinish = true;
    });
  }

  onScroll(event: any): void {
    const threshold = 100;
    const position = event.target.scrollTop + event.target.offsetHeight;
    const height = event.target.scrollHeight;

    if (position > height - threshold && (this.insightsListsPagination?.currentPage ?? 0) < (this.insightsListsPagination?.lastPage ?? 0) && this.isRequestFinish) {
      this.getInsightsLists();
    }
  }
}
